export const getChartOptions = ({ chartType = "barChart", cutout = "70%" }) => {
  const BASE_OPTIONS = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    responsive: true,
  };

  switch (chartType) {
    case "barChart":
      return {
        ...BASE_OPTIONS,
        plugins: {
          legend: {
            display: false,
          },

          title: {
            display: false,
          },
        },
      };
    case "doughnut":
      return {
        ...BASE_OPTIONS,
        plugins: {
          legend: {
            position: "bottom",
          },
        },
        cutout,
      };
    default:
      return BASE_OPTIONS;
  }
};
